/**
 * Evi Beauty — Custom Product Page JS
 * ===================================================================
 * Adapted from SkinVault for the Symmetry theme.
 *
 * Features:
 *   1. Price on ATC button (dynamic with qty)
 *   2. In-stock banner
 *   3. Backorder banner detection
 *   4. Info card (trust badges)
 *   5. FBT restyling ("Better Together")
 *   6. Custom sticky ATC bar with qty + price
 *   7. Bidirectional qty sync (main ↔ sticky)
 */

(function () {
  'use strict';

  /* =================================================================
     SHARED HELPERS
     ================================================================= */

  /** Read the current unit price from Shopify meta or visible price element */
  function getUnitPrice() {
    // Try meta tag first (most reliable)
    var meta = document.querySelector('meta[property="og:price:amount"]');
    if (meta) {
      var val = parseFloat(meta.content);
      if (!isNaN(val) && val > 0) return val;
    }
    // Fallback: visible price element
    var el = document.querySelector('.product-price .price-item--regular') ||
             document.querySelector('.product-price .money') ||
             document.querySelector('.product-price');
    if (el) {
      var text = el.textContent.replace(/[^0-9.]/g, '');
      return parseFloat(text) || 0;
    }
    return 0;
  }

  /** Format a dollar amount: $55 or $55.50 */
  function formatPrice(amount) {
    return (amount % 1 === 0) ? '$' + amount : '$' + amount.toFixed(2);
  }


  /* =================================================================
     1. PRICE ON ATC BUTTON
     ================================================================= */

  function initMainButton() {
    var mainBtn = document.querySelector('.quantity-submit-row button.add-to-cart');
    var mainQty = document.querySelector('#quantity');
    if (!mainBtn || !mainQty) return null;

    function updateMainPrice() {
      if (mainBtn.disabled) {
        mainBtn.textContent = 'Sold Out';
        mainBtn.classList.add('ev-sold-out');
        return;
      }
      mainBtn.classList.remove('ev-sold-out');
      var qty = parseInt(mainQty.value, 10) || 1;
      var total = getUnitPrice() * qty;
      mainBtn.textContent = formatPrice(total) + ' \u2014 ADD TO CART';
    }

    mainQty.addEventListener('input', updateMainPrice);
    mainQty.addEventListener('change', updateMainPrice);
    updateMainPrice();

    // Also listen for Symmetry's +/- button clicks
    var qtyDown = document.querySelector('[data-quantity="down"]');
    var qtyUp = document.querySelector('[data-quantity="up"]');
    if (qtyDown) qtyDown.addEventListener('click', function () { setTimeout(updateMainPrice, 50); });
    if (qtyUp) qtyUp.addEventListener('click', function () { setTimeout(updateMainPrice, 50); });

    return { updateMainPrice: updateMainPrice };
  }


  /* =================================================================
     2. IN-STOCK BANNER
     ================================================================= */

  function initInStockNotice() {
    if (document.querySelector('.ev-backorder-banner')) return;
    if (document.querySelector('.ev-instock-banner')) return;
    if (!document.body.classList.contains('template-product')) return;

    // Check if product is sold out — look for any sold-out indicators
    var isSoldOut = false;
    var allBtns = document.querySelectorAll('.quantity-submit-row button, .quantity-submit-row__submit button');
    allBtns.forEach(function (btn) {
      if (btn.disabled || /sold\s*out/i.test(btn.textContent)) isSoldOut = true;
    });
    // Also check for a standalone sold-out button the theme may render
    var standaloneBtn = document.querySelector('button.add-to-cart');
    if (standaloneBtn && /sold\s*out/i.test(standaloneBtn.textContent)) isSoldOut = true;
    if (isSoldOut) return;

    var mainAtcBtn = document.querySelector('.quantity-submit-row button.add-to-cart') ||
                     document.querySelector('.quantity-submit-row__submit button');
    if (mainAtcBtn && mainAtcBtn.disabled) return;

    // Insert before the quantity-submit-row
    var qtyRow = document.querySelector('.quantity-submit-row');
    if (!qtyRow) return;

    var banner = document.createElement('div');
    banner.className = 'ev-instock-banner';
    banner.innerHTML =
      '<div class="ev-instock-banner-inner">' +
        '<span class="ev-instock-banner-icon">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3a7d44" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M20 6L9 17l-5-5"/>' +
          '</svg>' +
        '</span>' +
        '<div class="ev-instock-banner-text">' +
          '<strong>In Stock \u2014 Ready to Ship</strong>' +
        '</div>' +
      '</div>';
    qtyRow.parentNode.insertBefore(banner, qtyRow);

    // Toggle visibility if product becomes sold out (e.g. variant change)
    if (mainAtcBtn) {
      function toggleBanner() {
        var btnSoldOut = mainAtcBtn.classList.contains('ev-sold-out') ||
                         mainAtcBtn.disabled ||
                         /sold\s*out/i.test(mainAtcBtn.textContent);
        banner.style.display = btnSoldOut ? 'none' : '';
      }
      toggleBanner();
      new MutationObserver(toggleBanner).observe(mainAtcBtn, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['class', 'disabled']
      });
    }
  }


  /* =================================================================
     3. BACKORDER BANNER
     ================================================================= */

  function initBackorderNotice() {
    var BACKORDER_REGEX = /\s*\[Backorder\s+Ships\s+In\s+(\d+\+?\s*Days?)\]/i;

    // Check all h1 / title elements
    var allH1 = document.querySelectorAll('h1, .product-title');
    var shippingNum = '';
    allH1.forEach(function (h1) {
      var match = h1.textContent.match(BACKORDER_REGEX);
      if (match) {
        shippingNum = match[1].replace(/\s*days?/i, '').replace(/\+/, '');
        h1.textContent = h1.textContent.replace(BACKORDER_REGEX, '');
      }
    });
    if (!shippingNum) return;

    // Clean breadcrumbs
    document.querySelectorAll('.breadcrumbs a, .breadcrumbs span').forEach(function (el) {
      if (BACKORDER_REGEX.test(el.textContent)) {
        el.textContent = el.textContent.replace(BACKORDER_REGEX, '');
      }
    });

    // Clean page title
    document.title = document.title.replace(BACKORDER_REGEX, '');

    if (!document.querySelector('.ev-backorder-banner')) {
      var qtyRow = document.querySelector('.quantity-submit-row');
      if (qtyRow) {
        var banner = document.createElement('div');
        banner.className = 'ev-backorder-banner';
        banner.innerHTML =
          '<div class="ev-backorder-banner-inner">' +
            '<span class="ev-backorder-banner-icon">&#128230;</span>' +
            '<div class="ev-backorder-banner-text">' +
              '<strong>This item is on its way to us</strong>' +
              '<span>Order now to secure yours \u2014 we\u2019ll ship it as soon as it arrives, typically in about ' + shippingNum + ' days.</span>' +
            '</div>' +
          '</div>';
        qtyRow.parentNode.insertBefore(banner, qtyRow);
      }
    }
  }


  /* =================================================================
     4. INFO CARD (Trust Badges)
     ================================================================= */

  function initInfoCard() {
    if (document.getElementById('ev-info-card')) return;
    if (!document.body.classList.contains('template-product')) return;

    // We want the info card AFTER the buy-buttons element, at the
    // .product-form level — NOT inside the narrow .has-spb grid.
    var buyButtons = document.querySelector('buy-buttons');
    if (!buyButtons) return;

    var card = document.createElement('div');
    card.id = 'ev-info-card';
    card.innerHTML =
      '<div class="ev-info-row">' +
        '<div class="ev-info-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#B5A87D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 18H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10l4 4v7a1 1 0 0 1-1 1h-2"/><circle cx="7.5" cy="18" r="2"/><circle cx="14.5" cy="18" r="2"/><path d="M16 6h4l3 3v5a1 1 0 0 1-1 1h-1"/></svg></div>' +
        '<div class="ev-info-text"><span class="ev-info-label">Free Shipping</span><span class="ev-info-detail">On all orders $99+ \u00a0\u00b7\u00a0 <a href="/policies/shipping-policy">Shipping Details</a></span></div>' +
      '</div>' +
      '<div class="ev-info-divider"></div>' +
      '<div class="ev-info-row">' +
        '<div class="ev-info-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#B5A87D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C8 10 5.9 16.17 3.82 21.34L2 21 3.79 15.55C5.32 11 8.5 7 17 5V1l7 7-7 7V8z"/></svg></div>' +
        '<div class="ev-info-text"><span class="ev-info-label">Clean + Natural Ingredients</span><span class="ev-info-detail">Expertly curated collection \u00a0\u00b7\u00a0 Holistic wellness</span></div>' +
      '</div>' +
      '<div class="ev-info-divider"></div>' +
      '<div class="ev-info-row">' +
        '<div class="ev-info-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#B5A87D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C9.5 2 7 4 7 7.5c0 3 2.5 6.5 5 10.5 2.5-4 5-7.5 5-10.5C17 4 14.5 2 12 2z"/><path d="M10.5 7.5L11.5 5.5 12.5 7.5 14.5 7.5 13 8.8 13.5 10.5 12 9.5 10.5 10.5 11 8.8 9.5 7.5z"/></svg></div>' +
        '<div class="ev-info-text"><span class="ev-info-label">Canadian Owned &amp; Operated</span><span class="ev-info-detail">All prices in CAD \u00a0\u00b7\u00a0 Ships from Canada \u00a0\u00b7\u00a0 No duties</span></div>' +
      '</div>';

    // Insert AFTER buy-buttons (at the .product-form level)
    buyButtons.parentNode.insertBefore(card, buyButtons.nextSibling);
  }


  /* =================================================================
     5. FBT RESTYLING — "Better Together"
     ================================================================= */

  function initFBTRestyling() {
    var fbt = document.querySelector('.cbb-frequently-bought-container');
    if (!fbt) return;
    if (fbt.dataset.evStyled) return;
    fbt.dataset.evStyled = 'true';

    // --- Relocate FBT into the right product column ---
    // Target: insert BEFORE the info card (which sits after buy-buttons).
    // Order: buy-buttons → FBT → info-card
    var infoCard = document.getElementById('ev-info-card');
    var buyButtons = document.querySelector('buy-buttons');

    if (infoCard && infoCard.parentNode) {
      // Place FBT right before the info card
      infoCard.parentNode.insertBefore(fbt, infoCard);
      fbt.dataset.evRelocated = 'true';
    } else if (buyButtons && buyButtons.parentNode) {
      // No info card yet — place after buy-buttons
      buyButtons.parentNode.insertBefore(fbt, buyButtons.nextSibling);
      fbt.dataset.evRelocated = 'true';
    }

    // --- Restyle title ---
    var title = fbt.querySelector('.cbb-frequently-bought-title');
    if (title) {
      title.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#939575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
        '</svg>' +
        'Better Together';
    }

    // Add subtitle
    if (!fbt.querySelector('.ev-fbt-subtitle')) {
      var subtitle = document.createElement('div');
      subtitle.className = 'ev-fbt-subtitle';
      subtitle.textContent = 'These items are frequently paired together.';
      if (title && title.nextSibling) {
        title.parentNode.insertBefore(subtitle, title.nextSibling);
      }
    }

    // Rename button
    var addBtn = fbt.querySelector('.cbb-frequently-bought-add-button');
    if (addBtn) {
      addBtn.textContent = 'ADD BUNDLE TO CART';
    }

    // Strip "This item: " prefix — it lives in span.translatable, not a label
    fbt.querySelectorAll('.cbb-frequently-bought-selector-list span.translatable').forEach(function (span) {
      if (span.textContent.indexOf('This item:') !== -1) {
        span.textContent = span.textContent.replace('This item: ', '').replace('This item:', '');
      }
    });

    // --- Reorder: move selector-list (checkboxes) into
    // recommendations-container so CSS flex order works ---
    var recContainer = fbt.querySelector('.cbb-frequently-bought-recommendations-container');
    var selectorList = fbt.querySelector('.cbb-frequently-bought-selector-list');
    if (recContainer && selectorList && selectorList.parentNode !== recContainer) {
      // Insert before the form (total + button) so checkboxes come first
      var form = recContainer.querySelector('.cbb-frequently-bought-form');
      if (form) {
        recContainer.insertBefore(selectorList, form);
      } else {
        recContainer.appendChild(selectorList);
      }
    }
  }


  /* =================================================================
     6. STICKY ADD-TO-CART BAR
     ================================================================= */

  function initStickyBar() {
    if (document.getElementById('ev-sticky-bar')) return;

    var mainAtcBtn = document.querySelector('.quantity-submit-row button.add-to-cart');
    if (!mainAtcBtn) return;

    // Build sticky bar HTML
    var bar = document.createElement('div');
    bar.id = 'ev-sticky-bar';
    bar.className = 'ev-sticky-hidden';

    var inner = document.createElement('div');
    inner.className = 'ev-sticky-inner';

    // Qty controls
    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'ev-sticky-qty';
    var minusBtn = document.createElement('button');
    minusBtn.textContent = '\u2212';
    minusBtn.setAttribute('aria-label', 'Decrease quantity');
    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.value = '1';
    qtyInput.min = '1';
    qtyInput.setAttribute('aria-label', 'Quantity');
    var plusBtn = document.createElement('button');
    plusBtn.textContent = '+';
    plusBtn.setAttribute('aria-label', 'Increase quantity');
    qtyWrap.appendChild(minusBtn);
    qtyWrap.appendChild(qtyInput);
    qtyWrap.appendChild(plusBtn);

    // ATC button
    var atcBtn = document.createElement('button');
    atcBtn.className = 'ev-sticky-atc-btn';
    atcBtn.textContent = formatPrice(getUnitPrice()) + ' \u2014 ADD TO CART';

    inner.appendChild(qtyWrap);
    inner.appendChild(atcBtn);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    // Qty +/- handlers
    minusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    plusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Update price on qty change
    function updateStickyPrice() {
      if (mainAtcBtn.disabled) {
        atcBtn.textContent = 'Sold Out';
        atcBtn.disabled = true;
        return;
      }
      atcBtn.disabled = false;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var total = getUnitPrice() * qty;
      atcBtn.textContent = formatPrice(total) + ' \u2014 ADD TO CART';
    }
    qtyInput.addEventListener('input', updateStickyPrice);
    qtyInput.addEventListener('change', updateStickyPrice);

    // ATC click — submit the main form with the sticky qty
    atcBtn.addEventListener('click', function () {
      var mainQty = document.querySelector('#quantity');
      if (mainQty) {
        mainQty.value = qtyInput.value;
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      mainAtcBtn.click();
    });

    // Show/hide based on main ATC visibility AND cart drawer state
    var cartDrawer = document.querySelector('cart-drawer, .js-cart-drawer');

    function updateVisibility() {
      // Hide when cart drawer is open (drawer sits at z-index 8001)
      var drawerOpen = cartDrawer && cartDrawer.hasAttribute('open');
      if (drawerOpen) {
        bar.classList.add('ev-sticky-hidden');
        return;
      }
      var rect = mainAtcBtn.getBoundingClientRect();
      var isMainVisible = rect.top < window.innerHeight && rect.bottom > 0;
      bar.classList.toggle('ev-sticky-hidden', isMainVisible);
    }

    // Watch cart drawer open/close
    if (cartDrawer) {
      new MutationObserver(updateVisibility).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    updateVisibility();

    return {
      qtyInput: qtyInput,
      updateStickyPrice: updateStickyPrice
    };
  }


  /* =================================================================
     7. BIDIRECTIONAL QTY SYNC (main ↔ sticky)
     ================================================================= */

  function syncQuantities(stickyRefs) {
    var mainQty = document.querySelector('#quantity');
    if (!mainQty || !stickyRefs || !stickyRefs.qtyInput) return;

    var stickyQty = stickyRefs.qtyInput;
    var syncing = false;

    function syncToSticky() {
      if (syncing) return;
      syncing = true;
      stickyQty.value = mainQty.value;
      stickyQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }
    function syncToMain() {
      if (syncing) return;
      syncing = true;
      mainQty.value = stickyQty.value;
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }

    mainQty.addEventListener('input', syncToSticky);
    mainQty.addEventListener('change', syncToSticky);
    stickyQty.addEventListener('input', syncToMain);
    stickyQty.addEventListener('change', syncToMain);

    // Also catch Symmetry's +/- buttons
    var qtyDown = document.querySelector('[data-quantity="down"]');
    var qtyUp = document.querySelector('[data-quantity="up"]');
    if (qtyDown) qtyDown.addEventListener('click', function () { setTimeout(syncToSticky, 50); });
    if (qtyUp) qtyUp.addEventListener('click', function () { setTimeout(syncToSticky, 50); });

    return {
      lastMainVal: mainQty.value,
      lastStickyVal: stickyQty.value,
      tick: function () {
        if (syncing) return;
        if (mainQty.value !== this.lastMainVal) {
          this.lastMainVal = mainQty.value;
          if (stickyQty.value !== mainQty.value) {
            syncing = true;
            stickyQty.value = mainQty.value;
            syncing = false;
          }
          this.lastStickyVal = stickyQty.value;
        } else if (stickyQty.value !== this.lastStickyVal) {
          this.lastStickyVal = stickyQty.value;
          if (mainQty.value !== stickyQty.value) {
            syncing = true;
            mainQty.value = stickyQty.value;
            syncing = false;
          }
          this.lastMainVal = mainQty.value;
        }
      }
    };
  }


  /* =================================================================
     8. VARIANT SELECTOR — Convert radios to dropdown, move above In Stock
     ================================================================= */

  function initVariantDropdown() {
    var variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;
    if (variantPicker.dataset.evConverted) return;

    // Find all option fieldsets (there may be more than one option, e.g. Size + Scent)
    var fieldsets = variantPicker.querySelectorAll('fieldset.option-selector');
    if (!fieldsets.length) return;

    // Create a wrapper div for all our custom dropdowns
    var dropdownWrap = document.createElement('div');
    dropdownWrap.className = 'ev-variant-dropdowns';

    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var optionName = legend ? legend.textContent.trim() : 'Option';

      // Collect radio values
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;

      // Find currently selected
      var selectedValue = '';
      radios.forEach(function (r) { if (r.checked) selectedValue = r.value; });
      if (!selectedValue && radios.length) selectedValue = radios[0].value;

      // Build a label + select pair
      var row = document.createElement('div');
      row.className = 'ev-variant-row';

      var label = document.createElement('label');
      label.className = 'ev-variant-label';
      label.textContent = optionName;

      var select = document.createElement('select');
      select.className = 'ev-variant-select';

      radios.forEach(function (r) {
        var opt = document.createElement('option');
        opt.value = r.value;
        opt.textContent = r.value;
        if (r.value === selectedValue) opt.selected = true;
        select.appendChild(opt);
      });

      // When dropdown changes, click the corresponding hidden radio
      select.addEventListener('change', function () {
        var val = select.value;
        radios.forEach(function (r) {
          if (r.value === val) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
            r.dispatchEvent(new Event('input', { bubbles: true }));
            // Also click it — some themes listen for click
            r.click();
          }
        });
      });

      row.appendChild(label);
      row.appendChild(select);
      dropdownWrap.appendChild(row);
    });

    // Hide the original fieldsets (keep in DOM for functionality)
    var inputRow = variantPicker.closest('.input-row') || variantPicker.parentElement;
    if (inputRow) {
      inputRow.style.position = 'absolute';
      inputRow.style.opacity = '0';
      inputRow.style.pointerEvents = 'none';
      inputRow.style.height = '0';
      inputRow.style.overflow = 'hidden';
    }

    // Move dropdown above the In Stock banner
    var instockBanner = document.querySelector('.ev-instock-banner');
    var backorderBanner = document.querySelector('.ev-backorder-banner');
    var targetBanner = instockBanner || backorderBanner;

    if (targetBanner && targetBanner.parentNode) {
      targetBanner.parentNode.insertBefore(dropdownWrap, targetBanner);
    } else {
      // Fallback: insert before the quantity row
      var qtyRow = document.querySelector('.quantity-submit-row');
      if (qtyRow && qtyRow.parentNode) {
        qtyRow.parentNode.insertBefore(dropdownWrap, qtyRow);
      }
    }

    variantPicker.dataset.evConverted = 'true';
  }


  /* =================================================================
     9. DESCRIPTION HEADING
     ================================================================= */

  function initDescriptionHeading() {
    var desc = document.querySelector('.product-description');
    if (!desc) return;
    if (desc.querySelector('.ev-desc-heading')) return;

    var heading = document.createElement('h3');
    heading.className = 'ev-desc-heading';
    heading.textContent = 'Description';
    desc.insertBefore(heading, desc.firstChild);
  }


  /* =================================================================
     MASTER INIT
     ================================================================= */

  function runAll() {
    // Only run on product pages
    if (!document.body.classList.contains('template-product')) {
      // On collection pages, clean backorder text from titles
      cleanCollectionTitles();
      return;
    }

    // 1. Backorder notice (must run before in-stock)
    initBackorderNotice();

    // 2. In-stock notice
    initInStockNotice();

    // 3. Price on ATC button
    var mainBtnRefs = initMainButton();

    // 4. Info card
    initInfoCard();

    // 5. FBT restyling
    initFBTRestyling();

    // 6. Sticky bar
    var stickyRefs = initStickyBar();

    // 7. Qty sync
    var syncRefs = syncQuantities(stickyRefs);

    // 8. Layout: move title above image gallery
    var productFormEl = document.querySelector('product-form.js-product');
    var titleRow = document.querySelector('.title-row');
    var mediaGallery = productFormEl ? productFormEl.querySelector('media-gallery') : null;
    if (titleRow && mediaGallery && productFormEl) {
      productFormEl.insertBefore(titleRow, mediaGallery);
      titleRow.dataset.evMoved = 'true';
    }

    // 9. Layout: hide main price (price is on ATC button)
    var priceDisplay = document.querySelector('.price-container .product-info__price');
    if (priceDisplay) {
      priceDisplay.style.display = 'none';
    }

    // 10. Layout: move installment message below ShopPay button
    var priceDescriptors = document.querySelector('.price-descriptors');
    var dynPayBtn = document.querySelector('.product-dynamic-payment-button');
    if (priceDescriptors && dynPayBtn && dynPayBtn.parentNode) {
      dynPayBtn.parentNode.insertBefore(priceDescriptors, dynPayBtn.nextSibling);
      priceDescriptors.dataset.evMoved = 'true';
    }

    // 11. Layout: move product description to full-width below both columns (desktop)
    var productDesc = document.querySelector('.product-description');
    if (productDesc && productFormEl) {
      productFormEl.appendChild(productDesc);
      productDesc.dataset.evMoved = 'true';
    }

    // 12. Variant selector: convert radios to dropdown, move above In Stock
    initVariantDropdown();

    // 13. Description heading
    initDescriptionHeading();

    // FBT might load late (app script), so retry
    var fbtAttempts = 0;
    var fbtPoll = setInterval(function () {
      fbtAttempts++;
      initFBTRestyling();
      if (fbtAttempts >= 20 || document.querySelector('.cbb-frequently-bought-container[data-ev-styled]')) {
        clearInterval(fbtPoll);
      }
    }, 500);

    // Unified tick — runs at 300ms to catch programmatic changes
    setInterval(function () {
      if (mainBtnRefs) mainBtnRefs.updateMainPrice();
      if (stickyRefs) stickyRefs.updateStickyPrice();
      if (syncRefs) syncRefs.tick();
    }, 300);
  }

  /** Clean [Backorder Ships In X Days] from titles on collection pages */
  function cleanCollectionTitles() {
    var BACKORDER_REGEX_GLOBAL = /\s*\[Backorder\s+Ships\s+In\s+\d+\+?\s*Days?\]/gi;
    document.querySelectorAll('.product-title a, .product-title, .product-card__title, h3 a').forEach(function (a) {
      if (BACKORDER_REGEX_GLOBAL.test(a.textContent)) {
        a.textContent = a.textContent.replace(BACKORDER_REGEX_GLOBAL, '');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();